export const MAX_PAGE_COUNT: number = 100;
